import { useEffect, useState } from 'react';
import { UserX } from 'lucide-react';

export default function BlockedUsersList() {
  const [blockedUsers, setBlockedUsers] = useState<string[]>([]);
  const [userDetails, setUserDetails] = useState<{[key: string]: {name: string, photo?: string}}>({});

  useEffect(() => {
    // Load blocked users from localStorage
    const blocked = JSON.parse(localStorage.getItem('blockedUsers') || '[]');
    setBlockedUsers(blocked);
    
    // Fetch details for blocked users
    const fetchUserDetails = async () => {
      const details: {[key: string]: {name: string, photo?: string}} = {};
      
      for (const userId of blocked) {
        try {
          // In a real app, you would fetch from your database
          // For demo purposes, we'll just store minimal info
          details[userId] = {
            name: `User ${userId.slice(0, 6)}`, // Placeholder name
            photo: undefined
          };
        } catch (error) {
          console.error('Error fetching user details:', error);
          details[userId] = { name: 'Unknown User' };
        }
      }
      
      setUserDetails(details);
    };
    
    fetchUserDetails();
  }, []);

  const handleUnblock = (userId: string) => {
    const updatedBlockedUsers = blockedUsers.filter(id => id !== userId);
    localStorage.setItem('blockedUsers', JSON.stringify(updatedBlockedUsers));
    setBlockedUsers(updatedBlockedUsers);
    
    // Remove from userDetails
    const newDetails = {...userDetails};
    delete newDetails[userId];
    setUserDetails(newDetails);
    
    alert('User unblocked successfully');
  };

  if (blockedUsers.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500">
        You haven't blocked any users yet.
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200">
      {blockedUsers.map(userId => (
        <div key={userId} className="flex items-center justify-between p-4">
          <div className="flex items-center space-x-3">
            {userDetails[userId]?.photo ? (
              <img 
                src={userDetails[userId]?.photo} 
                alt={userDetails[userId]?.name}
                className="h-10 w-10 rounded-full"
              />
            ) : (
              <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                <span className="text-gray-600">{userDetails[userId]?.name[0]}</span>
              </div>
            )}
            <span>{userDetails[userId]?.name}</span>
          </div>
          <button
            onClick={() => handleUnblock(userId)}
            className="flex items-center space-x-2 text-sm text-red-500 hover:text-red-700"
          >
            <UserX size={16} />
            <span>Unblock</span>
          </button>
        </div>
      ))}
    </div>
  );
}
